import axios from "axios";
import { Getdata } from "./api.service";

export const applySchoolColors = async () => {
  try {
    const res = await Getdata(
      `${process.env.REACT_APP_URL}/front/school/colors/${process.env.REACT_APP_SUBDOMAIN}`
    );

    console.log("school colors response:", res);

    if (res.status === 200 && res.data) {
      const { primary_color, secondary_color } = res.data;

      document.documentElement.style.setProperty(
        "--color-primary",
        primary_color || "#5E35B1"
      );

      document.documentElement.style.setProperty(
        "--color-secondary",
        secondary_color || "#BF360C"
      );
    }
  } catch (err) {
    console.error("Failed to apply school colors", err);

    // fallback colors
    document.documentElement.style.setProperty("--color-primary", "#5E35B1");
    document.documentElement.style.setProperty("--color-secondary", "#BF360C");
  }
};